
module.exports = {
  // TODO: change your profile information here
  name: "Chitranshu Gour",
  greeting: "Hey 👋",
  greetingDescription: "I'm Chitranshu Gour and I'm a Software Developer!",
  githubUrl: "https://github.com/chitranshu11",
  linkedinUrl: "https://linkedin.com/in/chitranshugour",
  cvLink: "https://drive.google.com/file/d/1MPgMVQFr6B3cGeqND88_p2aPcsb4Si07/view?usp=sharing",
  skills: [
    {name : "Programming Language", description : "Java CPP"},
    {name : "Data Structure" , description : "Data Structure & Algorithms"},
    {name : "Spring Boot" , description : "JPA REST APIs"},
    {name : "Web Development", description : "HTML CSS Javascript"},
    {name : "Android Development" , description : "Java SQLite"},
    {name: "Java", description : "J2SE J2EE"},
    {name : "Database", description : "MongoDB MySQL"},
    {name : "Other", description : "Git Eclipse IDE Android Studio"},

  ]
};
